module.exports = __webpack_public_path__ + "static/img/newsh5_banner_01_zh.ef083fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsh5_banner_01_zh.png
// module id = flgx
// module chunks = 34